import { HTMLAttributes } from "react";

export default function RecoilJS(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
    {...props}
      width="256"
      height="256"
      viewBox="0 0 256 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="256" height="256" rx="60" fill="white" />
      <g clipPath="url(#clip0_591_28354)">
        <path
          d="M128.004 23C137.785 23 145.708 30.9402 145.708 40.7432C145.708 48.0508 141.29 54.3313 134.98 57.0545L134.788 57.1359V64.6104C134.788 71.8258 140.139 77.9685 147.257 78.9718L147.473 79.0006L149.611 79.28C161.181 80.747 170.149 89.083 172.449 100.539C174.749 111.996 169.731 123.172 159.624 129.04C155.099 131.651 150.17 133.248 144.969 133.788L144.709 133.814L112.577 136.841C109.301 137.143 106.211 138.145 103.354 139.798C97.5221 143.174 96.3837 149.019 97.2666 153.35C98.1406 157.638 101.406 162.519 107.941 163.429L110.277 163.735C124.354 165.487 134.992 177.44 135.203 191.619L135.206 192.05V198.989C141.409 201.736 145.754 207.977 145.754 215.218C145.754 225.021 137.832 232.961 128.05 232.961C118.269 232.961 110.347 225.021 110.347 215.218C110.347 207.934 114.742 201.653 121.029 198.93L121.22 198.849V192.05C121.22 184.834 115.869 178.692 108.751 177.688L108.535 177.659L106.397 177.38C94.8271 175.913 85.8591 167.577 83.5591 156.121C81.2357 144.664 86.2773 133.488 96.3837 127.62C100.908 125.009 105.838 123.412 111.039 122.872L111.299 122.846L143.431 119.819C146.707 119.517 149.797 118.515 152.654 116.862C158.486 113.486 159.624 107.641 158.741 103.31C157.867 99.0225 154.602 94.1414 148.067 93.2308L145.731 92.9251C131.654 91.1731 121.016 79.2198 120.805 65.0408L120.802 64.6104V56.9496C114.622 54.1787 110.3 47.9616 110.3 40.7432C110.3 30.9402 118.223 23 128.004 23ZM149.285 141.731L159.206 152.628C166.589 160.765 170.693 171.253 170.775 182.217L170.776 182.549H156.767C156.767 175.034 154.011 167.839 149.019 162.251L148.867 162.082L132 143.547L145.475 142.266L145.901 142.219C146.911 142.104 147.918 141.971 148.913 141.798L149.285 141.731ZM98.01 73.5752C98.01 81.0902 100.765 88.2857 105.757 93.8739L105.909 94.0427L122.823 112.624L110.37 113.812L110 113.846C108.644 113.976 107.29 114.173 105.967 114.437L105.607 114.51L95.5938 103.496C88.2106 95.3821 84.1063 84.8714 84.0249 73.9075L84.0237 73.5752H98.01Z"
          fill="#1C1E21"
        />
      </g>
      <defs>
        <clipPath id="clip0_591_28354">
          <rect
            width="90"
            height="210"
            fill="white"
            transform="translate(83 23)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
